module.exports = __webpack_public_path__ + "assets/img/22_293_big.94409a76.jpg";